import React from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '../../lib/utils';

export const EmptyState = ({ icon: Icon = Inbox, title = 'Aucune donnée', description, action, className }) => (
  <div className={cn('flex flex-col items-center justify-center py-16 text-center', className)} data-testid="empty-state">
    <div className="p-4 rounded-full bg-gray-100 mb-4">
      <Icon className="h-8 w-8 text-gray-400" />
    </div>
    <h3 className="text-lg font-semibold text-gray-700">{title}</h3>
    {description && <p className="text-sm text-gray-500 mt-1 max-w-md">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default EmptyState;
